<template>
  <UserEmailColumn :row="owner.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserEmailColumn from '@/components/GraphqlDataTable/columns/User/UserEmailColumn.vue'

const OwnerEmailColumn = graphql(`
  fragment OwnerEmailColumn on Owner {
    id
    user {
      id
      ...UserEmailColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerEmailColumn>
  rowIndex?: number
}>()

const owner = computed(() => useFragment(OwnerEmailColumn, props.row))
</script>
